/**
 * Plain "i" circle icon for the top bar's info popover button — distinct
 * from InfoIcon.tsx (the yellow tooltip-on-hover icon used inline next to
 * form fields/notices elsewhere in the app), which this is NOT a duplicate
 * of despite the near-identical name it used to share when both lived as
 * local functions.
 */
export function InfoCircleIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="11" x2="12" y2="16" />
      <circle cx="12" cy="7.5" r="0.8" fill="currentColor" stroke="none" />
    </svg>
  );
}
